import { PageTemplate } from "@/components/Templates/PageTemplate";
import type { ExtraTab } from "@/components/Templates/types";
import { useScopeParams } from "@/hooks/useScopeParams";

import { BiomarkersGenomicsTab } from "./BiomarkersGenomicsTab";

/**
 * Analysis > Biomarkers & Genomics (Phase B).
 *
 * Standard data table over the `biomarkers` dataset plus a bespoke
 * "Biomarkers & Genomics" analytics tab (IHC / PD-L1 histograms, TMB scatter,
 * MSI counts, NGS oncoprint-lite, ctDNA kinetics). Gated by the `biomarkers`
 * feature flag at both the route and the nav item.
 */
export default function Biomarkers() {
  const { id } = useScopeParams();

  const extraTabs: ExtraTab[] = [
    {
      type: "custom",
      key: "biomarkers-genomics",
      title: "Biomarkers & Genomics",
      component: BiomarkersGenomicsTab,
      toolbar: { showOnly: ["guide"] },
    },
  ];

  return (
    <PageTemplate
      title="Analysis: Biomarkers & Genomics"
      tooltipText="Explore oncology biomarker and genomics analytics — IHC (B7-H3, PD-L1), TMB/MSI, NGS key alterations and ctDNA kinetics."
      type="biomarkers"
      constants={{
        wikiLink: "/wiki/guides/exploration-analysis-biomarkers",
        idLink: (subjectId: string) => `/${id}/subjects/overview/${subjectId}`,
      }}
      extraTabs={extraTabs}
    />
  );
}
